export enum Cache {
  ACCOUNT_INFO = "ACCOUNT_INFO", // 用户登录信息;
  LOCALE = "i18n_redirected", // 语言环境;
  COOKIE_ACCEPT = "cookie_accept", // Cookie 同意;
  FAC_TOKEN = "FAC_TOKEN", // third part login token, like google, facebook, etc.;
  UPLOAD_MODEL_DRAFT = "UPLOAD_MODEL_DRAFT", // 上传模型草稿;
  TMF_MODELRENDER_OBJECT = "TMF_MODELRENDER_OBJECT", // 模型数据缓存
  ELEGOO_DEVICE = "elegoo_device", // 选中的设备名称;
  PLATE_INFO = "plate_info", // 热盘信息;
  ACCESS_TOKEN = "ACCESS_TOKEN",
  REFRESH_TOKEN = "REFRESH_TOKEN",
  EXPIRES_TIME = "EXPIRES_TIME",
  USER_ID = "USER_ID",
  UUID = "UUID",
  LIST = "LIST", // 列表;
  MODEL_LIST = "MODEL_LIST", // 模型列表;
  SEARCH_MODEL_LIST = "SEARCH_MODEL_LIST", // 模型搜索列表;
  SEARCH_COLLECTION_LIST = "SEARCH_COLLECTION_LIST", // 合集搜索列表;
  SEARCH_CREATOR_LIST = "SEARCH_CREATOR_LIST", // 创作者搜索列表;
  MESSAGE = "MESSAGE", // 消息缓存;
  TASK_ID = "TASK_ID", // 任务ID
  FIRSTLOGIN = "FIRSTLOGIN", //首次登录
  HAS_SET_ELEGOO_SLICER = "HAS_SET_ELEGOO_SLICER", // 是否已经设置 Elegoo Slicer
  HAS_SET_ORCA_SLICER = "HAS_SET_ORCA_SLICER", // 是否已经设置 Orca Slicer
  CLAIM = "CLAIM", // 认领
}
